// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__13nll","description":"PatientConsentPreview_description__2xCOf"};